import { Auth } from "aws-amplify"

export default {
    async token() {
        return await Auth.currentSession()
    }
}